import styled from "styled-components";

/**
 * Container principal do rodapé.
 */
export const FooterContainer = styled.div`
  padding: ${({ theme }) => theme.spacing(2)} ${({ theme }) => theme.spacing(4)}
    ${({ theme }) => theme.spacing(4)} 0;
  justify-content: space-between;
  align-items: center;
  display: flex;

  @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    background-color: ${({ theme }) => theme.colors.white};
    border-top: 1px solid ${({ theme }) => theme.colors.lightGray};
    padding: ${({ theme }) => theme.spacing(3)}
      ${({ theme }) => theme.spacing(2)}
      calc(${({ theme }) => theme.spacing(6)} + env(safe-area-inset-bottom));
    box-sizing: border-box;
    flex: 0 0 auto;
    min-height: calc(96px + env(safe-area-inset-bottom));
    position: relative;
    z-index: 2;
    width: 100%;
  }
`;

/**
 * Botão de ação no rodapé.
 */
export const FooterButton = styled.button.withConfig({
  shouldForwardProp: (prop) => !["primary"].includes(prop),
})<{ primary?: boolean }>`
  padding: ${({ theme }) => theme.spacing(0.25)}
    ${({ theme }) => theme.spacing(8)};
  border-radius: ${({ theme }) => theme.borderRadius.extraLarge};
  background-color: ${({ theme, primary }) =>
    primary ? theme.colors.yellow : "transparent"};
  gap: ${({ theme }) => theme.spacing(1)};
  transition: all 0.3s ease;
  align-items: center;
  cursor: pointer;
  display: flex;
  border: none;

  &:hover {
    background-color: ${({ theme, primary }) =>
      primary ? theme.colors.orange : theme.colors.transparent};
  }

  & * {
    cursor: inherit;
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    padding: ${({ theme }) => theme.spacing(1)}
      ${({ theme }) => theme.spacing(3)};

    ${({ primary }) => primary && "flex: 0 1 55%; justify-content: center;"}
  }
`;
